import rateQuizDialogInit from './rateQuizDialog';
export default rateQuizDialogInit
